// extracted by mini-css-extract-plugin
export default {"indicator":"MoreBelow_indicator__haSG5","visible":"MoreBelow_visible__u-Wwi","down":"MoreBelow_down__8SEYH"};